export default __webpack_public_path__ + "static/media/hiringIntial.1b373c10.svg";